<template>
  <v-dialog v-model="modal" max-width="700">
    <v-form ref="form" :readonly="working">
      <v-card>
        <v-card-title> Supprimer l'invitation</v-card-title>
        <v-card-text>
          <p>Vous allez supprimer cette invitation.</p>
          <p>Confirmez vous la suppression ?</p>
        </v-card-text>
        <v-card-actions>
          <v-btn data-testid="valider-supprimer-invitation" :loading="working" @click="valide" color="primary"> Supprimer </v-btn>
          <v-btn data-testid="annuler-supprimer-invitation" :disabled="working" @click="ferme">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import makeRules from "@/mixins/makeRules";
import makeDialog from "@/mixins/makeDialog";
import { associationService } from "@/services";
export default {
  mixins: [
    makeRules({ inject: false }),
    makeRemoteWorker({ provide: false }),
    makeDialog,
  ],
  data() {
    return {
      invitation: null,
      association: null,
    };
  },
  methods: {
    demarre(association, invitation, next) {
      this.invitation = invitation;
      this.association = association;
      this.ouvre(next);
    },

    valide() {
      this.doWork({
        forms: [this.$refs.form],
        work() {
          return associationService.supprimerInvitation(
            this.association,
            this.invitation.tacheRattachement
            )//.catch(error => {
            //return Promise.reject(error.response.data.libelle || "Veuillez rafraichir la page.");
        //});
        },
        callback() {
          this.confirmeValeur(this.invitation);
        },
        successText: "L'invitation a été supprimée",
        errorText: "Erreur durant la suppression de l'invitation.",
      });
    },
  },
};
</script>
